import { Injectable } from '@angular/core';
import {Theme, blueTheme, defaultTheme, themeList, lifeFileTheme, pemTheme, palmersTheme, boosstTheme, weightmansTheme, NWRTheme, bluecoatTheme} from './ThemeInterface';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  public theme;
  public active: Theme;
  public availableThemes: Theme[] = [blueTheme, defaultTheme, lifeFileTheme, pemTheme, palmersTheme, boosstTheme, weightmansTheme, NWRTheme, bluecoatTheme];

  constructor() {
    const windowHostName = window.location.hostname;
    const theme = window['ZP_CONFIG'].themeMap[windowHostName] || 'default';
      this.setActiveTheme(theme)
  }

  setWhileLabel() {
    this.setActiveTheme('demo')
    this.theme = 'white-label'
  }

  setDefaultTheme() {
    this.setActiveTheme('default');
  }

  setBlueTheme(): void {
    this.setActiveTheme('demo');
  }

  setlifeFileTheme(): void {
    this.setActiveTheme('lifeFile');
  }

  setPemTheme(): void {
    this.setActiveTheme('pemTheme');
  }

  setPalmersTheme(): void {
    this.setActiveTheme('palmersTheme');
  }

  setBoostTheme(): void {
    this.setActiveTheme('boosstTheme');
  }

  setWeightmansTheme(): void {
    this.setActiveTheme('weightmansTheme');
  }

  setNWRTheme(): void {
    this.setActiveTheme('NWRTheme');
  }

  setBluecoatTheme(): void {
    this.setActiveTheme('bluecoatTheme');
  }

  setActiveTheme(theme: string): void {
    console.log('Active theme: ', theme);
    this.availableThemes.forEach(t => document.body.classList.remove(`theme-${t.theme}`));
    this.active = themeList[theme];
    this.theme = this.active.theme;
    document.body.classList.add(`theme-${this.active.theme}`);

    Object.keys(this.active.properties).forEach(property => {
      document.documentElement.style.setProperty(
        property,
        this.active.properties[property]
      );
    });
  }



}
